import { StorageType } from "client/utils"
import { clientSocket } from "client/socketApi"
import { SOCKET_CLEAR_SERVER_DRIVE_CONNECTION } from "const"


// emitters
// eslint-disable-next-line import/prefer-default-export
export const clearServerDriveConnection = (accountId: number, storage: StorageType) => {
    clientSocket.emit(SOCKET_CLEAR_SERVER_DRIVE_CONNECTION, accountId, storage)
}
